<script>

const config = require('@/config.js')[ process.env.NODE_ENV || 'local' ];

export default {

    name: 'item-qrcode',
    props: [ 'item' ],
    data() {
        return {
            data: {
            }
        }
    },
    computed: {
        backend_url() { return config.backend_url; },
        viewer_url() { return config.viewer_url; },
        validated_by_node() {
            return this.item.config.send_error === null && this.item.config.hasOwnProperty('node_response') && this.item.config.node_error === null;
        },
    },
    methods: {},
    created() {},

}

</script>

<template>

    <span v-if="validated_by_node === false" style="opacity: 0.6">
        <icon name="qrcode"/>
    </span>

    <a v-else-if="validated_by_node" size="sm" variant="light" :href="viewer_url + item.config.node_response.code" target="_blank">
        <icon name="qrcode"/>
    </a>

</template>


